module.exports = __webpack_public_path__ + "static/media/GWL 2.d6269b0d.jpg";